import { default as officeProgramsTypes } from "./types";

const {
  FETCH_OFFICE_PROGRAMS_REQUEST,
  FETCH_OFFICE_PROGRAMS_SUCCESS,
  FETCH_OFFICE_PROGRAMS_FAILURE,
} = officeProgramsTypes;

const initialState = {
  isLoading: false,
  list: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_OFFICE_PROGRAMS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_OFFICE_PROGRAMS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
        error: "",
      };
    case FETCH_OFFICE_PROGRAMS_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
